export default {
  device: null,
};
